import { SettingsPage } from "@/components/v2/settings-page";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CopyId } from "@/components/v2/copy-id";
import { useCurrentUser } from "@/hooks/use-current-user";
import { useMyAccounts } from "@/hooks/use-accounts";

function Field({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <p className="typo-label text-[color:var(--color-text-md)] uppercase mb-1">
        {label}
      </p>
      {children}
    </div>
  );
}

export default function V2SettingsAccountPage() {
  const currentUser = useCurrentUser();
  const { data: accountData } = useMyAccounts();

  const activeAccount = accountData?.accounts.find(
    (a) => a.id === accountData.active_account_id,
  );

  return (
    <SettingsPage
      breadcrumbs={[
        { label: "Settings" },
        { label: "Administration" },
        { label: "Account" },
      ]}
      title="Account"
      subtitle="Account-level settings and plan information."
    >
      <Card>
        <CardHeader>
          <CardTitle className="typo-heading">Account Details</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Field label="Account Name">
            <p className="typo-body text-[color:var(--color-text-hi)]">
              {activeAccount?.name ?? "—"}
            </p>
          </Field>
          <Field label="Account Slug">
            {activeAccount?.slug ? (
              <CopyId
                variant="compact"
                value={activeAccount.slug}
                ariaLabel="Copy account slug"
              />
            ) : (
              <p className="typo-mono text-sm text-[color:var(--color-text-hi)]">
                —
              </p>
            )}
          </Field>
          <Field label="Account ID">
            {currentUser?.accountId ? (
              <CopyId
                variant="compact"
                value={currentUser.accountId}
                ariaLabel="Copy account ID"
              />
            ) : (
              <p className="typo-mono text-sm text-[color:var(--color-text-hi)]">
                —
              </p>
            )}
          </Field>
          <Field label="Role">
            <p className="typo-body text-[color:var(--color-text-hi)] capitalize">
              {currentUser?.accountRole ?? "—"}
            </p>
          </Field>
        </CardContent>
      </Card>

      <Card className="border-destructive/30">
        <CardHeader>
          <CardTitle className="typo-heading text-destructive">
            Danger Zone
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="typo-body text-[color:var(--color-text-md)]">
            Account deletion is not available in this interface. Contact Adva
            support.
          </p>
        </CardContent>
      </Card>
    </SettingsPage>
  );
}
